import React from 'react'
import styled, { css } from 'styled-components'

const width = '83.372'
const height = '11.672'
const viewBox = '0 0 283.464 39.685'

const getDimensions = () => ({
  height,
  width
})

const getDimensionsCss = () => css`
  width: ${width}px;
  height: ${height}px;
`

const Image = styled.svg`
  ${({ noStyles }) => (!noStyles ? getDimensionsCss() : null)}
`

const defaultProps = {
  children: [
    <path
      fill="#A5ADBA"
      d="m0,39.685l5.251-8.402h30.458c1.725,0,2.851-1.125,2.851-2.851v-4.876H12.378c-7.802,0-11.253-3.451-11.253-11.103v-3.301C1.125,3.451,4.501,0,9.827,0h.6v12.303c0,1.725,1.125,2.851,2.851,2.851h25.356c5.776,0,9.227,3.451,9.227,9.077v4.351c0,7.427-3.676,11.103-11.253,11.103H0Zm182.516-8.552h23.556c3.901,0,6.377-2.401,6.377-6.152v-10.278c0-3.751-2.476-6.152-6.377-6.152h-23.556v22.581Zm-9.452,8.552V0h33.233c9.903,0,15.604,5.701,15.604,15.154v9.377c0,9.452-5.701,15.154-15.604,15.154h-33.233Zm-45.807-8.552h19.88c3.601,0,5.926-2.251,5.926-5.776v-11.028c0-3.526-2.326-5.776-5.926-5.776h-19.88c-3.601,0-5.926,2.251-5.926,5.776v11.028c0,3.526,2.326,5.776,5.926,5.776Zm20.105,8.552h-20.33c-9.602,0-15.154-5.551-15.154-14.779v-10.128c0-9.227,5.551-14.779,15.154-14.779h20.33c9.602,0,15.154,5.551,15.154,14.779v10.128c0,9.227-5.551,14.779-15.154,14.779Zm78.412,0L248.055,0h13.128l22.281,39.685h-10.803l-3.826-6.827h-18.98l-5.101-8.102-8.402,14.929h-10.578Zm19.205-15.379h19.055l-9.527-16.879-9.527,16.879ZM19.73,8.252L14.329,0h32.633l-5.251,8.252h-21.981Zm38.533,31.433V0h9.452v15.454h12.528L96.523,0h12.528l-20.705,19.73,21.08,19.955h-13.278l-16.279-15.679h-12.153v15.679h-9.452Z"
      key="key-0"
    />
  ],
  viewBox
}

export default Object.assign(Image, {
  getDimensions,
  getDimensionsCss,
  defaultProps,
  displayName: 'BrandSkoda'
})
